document.addEventListener('DOMContentLoaded', function (){

    const links = document.getElementsByTagName('a');
    addEventListenerToExternalLinks(links);

});


export function addEventListenerToExternalLinks(links){
    const homeUrl = sanitizeURL(wp_environment_values.home_url,true, true, true);


    if(homeUrl){
        for(let link of links){
            try{
                let href = link.getAttribute('href');


                if(href && href.startsWith("http")){
                    // check for http to ignore links like 'tel' or 'mailto'. All bool params must be true!
                    let baseUrl = sanitizeURL(href, true, true, true);

                    if(baseUrl.localeCompare(homeUrl) !== 0 && !link.classList.contains('ume-starter-floating-teaser-link')){
                        // strings are not identical -> referring to an external site
                        link.addEventListener('click', function (event){
                            event.stopPropagation();
                            event.preventDefault();

                            let displayedUrl = baseUrl;
                            displayedUrl = sanitizeURL(href, true, true, false);

                            let modalInstance = document.createElement('div');
                            modalInstance.classList.add('externalLinkModal__wrapper');
                            modalInstance.innerHTML = "<div class='externalLinkModal__inner'>" +
                                "<button class='externalLinkModal__closeButton' type='button' role='button' id='closeBtn' aria-label='Modal schließen'>X</button>" +
                                "<p>Sie werden weitergeleitet auf die Webseite:</p>" +
                                "<p><span>" + displayedUrl + "</span></p>" +
                                "<a class='externalLinkModal__inner__link' href='" + href + "' target='_blank' rel='noopener noreferrer'>Okay, weiter</a>" +
                                "</div>";

                            document.body.appendChild(modalInstance);

                            addEventHandlingToModal();
                        });
                    }
                }
            }
            catch (e){
                console.error(e.message);
            }

        }
    }
}




function addEventHandlingToModal(){
    let modal = document.body.querySelector('.externalLinkModal__wrapper');

    let inner = modal.querySelector('.externalLinkModal__inner');
    let closeBtn = modal.querySelector('#closeBtn');
    let linkBtn = modal.querySelector('.externalLinkModal__inner__link');
    let oldFocus = document.activeElement;
    linkBtn.focus();
    closeBtn.addEventListener('click', function (event){
        if(event.detail === 0){
            event.preventDefault();
            modal.remove();
            oldFocus.focus();
            return;
        }
       modal.remove();
    });

    linkBtn.addEventListener('click', function (){
        modal.remove();
    });
    modal.addEventListener('keydown', function(event){
        if (event.isComposing || event.keyCode === 229) {
            return;
        }
        if (event.code === 'Escape') {
            event.preventDefault();
            modal.remove();
            oldFocus.focus();
        }
        if (event.code === 'Tab') {
            let currentlyActive = document.activeElement;
            if(currentlyActive.classList.contains('externalLinkModal__inner__link') && event.shiftKey === false ||  (currentlyActive.classList.contains('externalLinkModal__closeButton') && event.shiftKey === true)){
                event.preventDefault();
                modal.remove();
                oldFocus.focus();
            }


        }
    });

    //close modal when clicking outside the inner modal div
    modal.addEventListener('mousedown', function (){
        const innerSelector = inner.getAttribute('class');
        const isHovered = inner.parentElement.querySelector('.' + innerSelector + ':hover') != null;

        if(!isHovered){
            modal.remove();
        }
    });
}


function openExternalLinkModal(event){
    let target = event.target;
    let targetUrl = target.getAttribute('href');

    event.stopPropagation();
    event.preventDefault();



}

/**
 * Removes protocol and the www prefix if existing in the url
 * @param url
 * @param protocol
 * @param path
 * @param www
 * @returns {*}
 */
function sanitizeURL(url, protocol, path, www){
    if(url){
        if(protocol){
            url = url.split("//")[1];
        }
        if(path){
            url = url.split("/")[0];
        }

        if(www && url.startsWith('www')){
            url = url.split('www.')[1];
        }
    }

    return url;
}
